'use strict';

var Backbone = require('dibs-backbone');

var GlobalContextBaseView = Backbone.BaseView.extend({
    constructor: function(options, parentView) {
        options = options || {};
        this.context = options.context;
        if (!this.context) {
            throw new Error('No context was provided to GlobalContextBaseView');
        }

        return Backbone.BaseView.call(this, options, parentView);
    },
    getContext: function() {
        return this.context;
    },
});

module.exports = GlobalContextBaseView;



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/reactHelpers/GlobalContextBaseView.js
// module id = 121
// module chunks = 4 5 7 8 10 20 22 24 29